export function useLocalStorage() {
  const setItem = async (key, value) => window.localStorage.setItem(key, value)
  const getItem = async (key) => window.localStorage.getItem(key)
  return {
    setItem,
    getItem,
  }
}
